// *******************************************************************************
// E publication form
// *******************************************************************************
const downloadPdf = (fileUrl) => {
  const a = document.createElement('a');
  a.href = fileUrl;
  console.log(fileUrl.split("/").pop());
  a.setAttribute('download', fileUrl.split("/").pop());
  a.click();
};

document.addEventListener('DOMContentLoaded', () => {
  const ePublicationForm = document.getElementById('e-publication-form');
  const loadingHtml = document.querySelector('.loading');
  const recaptcha = document.querySelector('.g-captcha')

  if (ePublicationForm && recaptcha) {
    const recaptchaKey = recaptcha.getAttribute('data-sitekey');
    const fv = FormValidation.formValidation(ePublicationForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.e-publication-modal__form-group'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.e-publication-modal__form-group');
        if (value === '') {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }

        if (!e.valid) {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': true,
          });
        } else {
          FormValidation.utils.classSet(container, {
            'is-validation-failed': false,
          });
        }
      })
      .on('core.form.valid', () => {
        loadingHtml.classList.add('is-active');
        grecaptcha.ready(() => {
          grecaptcha.execute(recaptchaKey, { action: 'saveEmailForPublications' }).then((token) => {
            const formDataInput = new FormData();
            const pdfID = document.querySelector('.e-publication-modal').dataset.id;
            formDataInput.append('action', 'saveEmailForPublications');
            formDataInput.append('token', token);
            formDataInput.append('id', pdfID);
            formDataInput.append('lang', localData.lang);
            formDataInput.append('email', ePublicationForm.querySelector('input').value);
            axios
              .post(localData.siteURL, formDataInput, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                if (response.data.data.status === 200) {
                  const boxLink = document.querySelector(`[data-id=${CSS.escape(pdfID)}]`);
                  const pdfLink = boxLink.querySelector('.mod-link--download').href;
                  downloadPdf(pdfLink);
                  document.querySelector('.publication-form').hidden = true;
                  document.querySelector('.publication-success').hidden = false;
                } else {
                  ePublicationForm.innerHTML = `${response.data.data.msg}`;
                }
                loadingHtml.classList.remove('is-active');
              })
              .catch((err) => {
                console.error(err);
              });
          });
        });
      });
  }
});

// *******************************************************************************
// Close Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.e-publication-modal').forEach((el) => {
      const modalBox = el;
      modalBox.classList.remove('is-open-modal');
      setTimeout(() => {
        /* eslint-enable no-param-reassign */
        modalBox.querySelector('.publication-form').hidden = false;
        modalBox.querySelector('.publication-success').hidden = true;
      }, 800);
    });
  }
});

attachEvent('.e-publication-modal__close', 'click', (ev) => {
  const parentModal = ev.target.closest('.e-publication-modal');
  parentModal.classList.remove('is-open-modal');
  setTimeout(() => {
    parentModal.querySelector('.publication-form').hidden = false;
    parentModal.querySelector('.publication-success').hidden = true;
  }, 800);
});

attachEvent('.e-publication-btn', 'click', (ev) => {
  const parentElem = ev.target.closest('.publication-card-list');
  const modalElem = parentElem.querySelector('.e-publication-modal');
  modalElem.classList.add('is-open-modal');
  modalElem.setAttribute('data-id', ev.target.closest('.publication-card').dataset.id);
  ev.preventDefault();
});
